import { render, staticRenderFns } from "./FileSearchWrapper.vue?vue&type=template&id=8f901ac8&scoped=true&"
import script from "./FileSearchWrapper.vue?vue&type=script&lang=js&"
export * from "./FileSearchWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FileSearchWrapper.vue?vue&type=style&index=0&id=8f901ac8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f901ac8",
  null
  
)

export default component.exports